$(function () {    
    $('.required').parent().prev().addClass('label-required')
})


// WEBPACK FOOTER //
// ./resources/assets/js/components/add-required-label.js